module.exports = __webpack_public_path__ + "80de9cc599cabd8367644f85e9b751ca.png";